import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SidebarUpdateComponent } from 'src/app/@amiga-pyme/class/sidebar-update.class';
import { STOCK_TTL_ES } from '../../../stock.interface';
import { StockService } from '../../../stock.service';

@Component({
  selector: 'pg-stock-quantity-sidebar',
  templateUrl: './stock-quantity-sidebar.component.html',
  providers: [MessageService]
})
export class StockQuantitySidebarComponent extends SidebarUpdateComponent {
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private serviceBase: StockService
  ) {
    super(STOCK_TTL_ES, serviceBase);
  }
  itemStock: { label: string; value: string }[];
  format = {};
  nameFormat = '';
  ngOnInit() {
    const { selectedParent, selectedChild } = this.item;
    this.format = selectedParent.format;
    this.nameFormat = selectedChild.format;
    this.item = { ...selectedParent, ...selectedChild };
    this.setItemInSideBar();
    const quantity = this.item?.quantity ? this.item.quantity : 0;
    this.fg = this.fb.group({
      newQuantity: [quantity, [Validators.required, Validators.min(0)]]
    });
  }

  onSubmit() {
    const updateQuantity = this.fg.value;
    const newFormat = this.format;
    newFormat[this.nameFormat].stock = updateQuantity.newQuantity;
    this.updateItem$({
      format: newFormat
    });
  }

  setItemInSideBar() {
    const fieldsStock = {
      branchStoreName: 'Sucursal',
      productName: 'Producto',
      format: 'Formato',
      subFormat: 'Sub Formato',
      expAt: 'Exp. en',
      purchasePrice: 'Precio Compra',
      profitMargin: 'Margen',
      precio: 'Precio Venta',
      stock: 'Stock'
    };
    const keysStock = Object.keys(fieldsStock);
    this.itemStock = keysStock.map((key) => {
      return {
        label: fieldsStock[key],
        value: this.item[key]
      };
    });
  }
}
